<template>

  <base-subscription-form/>

</template>


<script >
import BaseSubscriptionForm from "@/plugin/components/dashboard/AllSubscription/BaseSubscriptionForm.vue";

export default {
  name: "CreatSubscription",
  components: {BaseSubscriptionForm},
}

</script>


<style scoped>

</style>